export const babysitterTasksOptions = [
  {
    key: "feeding",
    label:
      "Feeding (milk, solid food, snacks – client provides ingredients if needed)",
    caption:
      "Babysitter handles feeding only. Parents must provide food/ingredients. Not responsible for special diets beyond instructions.",
  },
  {
    key: "diapering",
    label: "Diapering & Toileting",
  },
  {
    key: "bathing",
    label: "Bathing & Hygiene (supervised bath)",
  },
  {
    key: "napBedtime",
    label: "Nap & Bedtime Routines",
  },
  {
    key: "playEngagement",
    label:
      "Play & Engagement Activities (e.g., reading, coloring, toys, music)",
    caption:
      "Babysitter can supervise and encourage reading/play but not provide formal teaching or tutoring.",
  },
  {
    key: "lightHousehold",
    label:
      "Light Household Help (cleaning up after child, toys, minor tidying)",
    caption:
      "Babysitter can tidy toys or small messes related to childcare only. No full house cleaning.",
  },
];

export const healthConditionOptions = [
  { key: "fever", label: "Fever or recent illness (cough, flu, HFMD, etc.)" },
  { key: "poorFeeding", label: "Poor feeding or dehydration" },
  {
    key: "breathingDifficulties",
    label: "Breathing difficulties or chest issues",
  },
  { key: "dizzinessFainting", label: "Dizziness / fainting episodes" },
  {
    key: "allergicReactions",
    label: "Allergic reactions (food, medication, environment)",
  },
  {
    key: "behavioralConcerns",
    label: "Behavioral concerns (aggression, self-harm tendencies)",
  },
  {
    key: "specialCareNeeds",
    label: "Special care needs (tube feeding, medical devices)",
  },
];

export const babySitterWADescription =
  "If your child has higher or more complex care needs (e.g., recent illness, poor feeding, breathing difficulties, special medical requirements), our care consultants are here to help. Chat with us on WhatsApp so we can assess and match the right sitter.";
